module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Bell_01.923b7954.png";